import Vue from "vue";
import VueRouter from "vue-router";
import datamodel from "./datamodel"
import modelTemporary from "./modelTemporary.js"
import teamInfo from "./teamInfo.js"
import activity from "./activity"
import team from "./team"
import agreement from "./agreement"
import liveRoom from "./liveRoom"
import database from "./database"
import user from "./user"
Vue.use(VueRouter);

const routes = [
    ...datamodel,
    ...teamInfo,
    ...team,
    {
        path: '*',
        redirect: '/model/corpus'
    },
    {
        path: '/test11',
        name: 'test',
        component: () => import("../views/test.vue")
    },
    {
        path: '/download',
        name: 'download',
        component: () => import("../views/download.vue")
    },
    {
        path: '/vip',
        name: 'vip',
        component: () => import("../views/vip/vip.vue")
    },
    {
        path: '/matchRecord',
        name: 'matchRecord',
        component: () => import("../views/expert/matchRecord.vue")
    },
    {
        path: '/talent',
        name: 'talent',
        component: () => import("../views/talent/index.vue")
    },
    {
        path: '/privacy',
        name: 'privacy',
        component: () => import("../views/metasport/privacy.vue")
    },
    {
        path: '/agreement',
        name: 'agreement',
        component: () => import("../views/metasport/useragree.vue")
    },
    {
        path: '/weChatRecharge',
        name: 'weChatRecharge',
        component: () => import("../views/other/weChatRecharge.vue")
    },
    ...user,
    ...modelTemporary,
    ...activity,
    ...team,
    ...agreement,
    ...liveRoom,
    ...database
];
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push (location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch(err => err)
};
const router = new VueRouter({
    routes,
    mode: 'history',
    // 路由切换时，更新显示坐标
    scrollBehavior (to, from, savedPosition) {
        const position = {}
        if (to.matched.some(m => m.meta.scrollToTop)) {
            position.x = 0
            position.y = 0
        }
        return position
    }
});

export default router;
